import { render, staticRenderFns } from "./Upsells.vue?vue&type=template&id=177faeba&"
import script from "./Upsells.vue?vue&type=script&lang=js&"
export * from "./Upsells.vue?vue&type=script&lang=js&"
import style0 from "./Upsells.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports